import vuex from '@/store'
import router from '@/router'
import service from '@/services'
import { ElMessageBox } from 'element-plus'
import { $t as lang } from '@/Tool'
import { removeParamAndRefresh } from '@/Tool/index'
import introJs from 'intro.js'

let isLoginOut: boolean = false
const isHuawei = localStorage.getItem('isHuaweiyun')
const isSchool = localStorage.getItem('isSchool')

// 退出登陆
async function loginOut(orgid: number) {
  try {
    const resp = await service.Scrm_sys_api.srcmLogin.loginOut({ orgid })
    if (resp.success) {
      vuex.commit('clear_data')
      isLoginOut = true
      removeParamAndRefresh('token')
      if (!isSchool && !isHuawei) {
        router.replace('/login')
      } else {
        if (isSchool == "school") {
          router.replace('/school/login');
        }
        if (isHuawei === 'huawei') {
          router.replace('/huaweiyun/login')
        }
      }
      removeNode()
      return Promise.resolve()
    }
  } catch (e: any) {
    return Promise.reject(e)
  }
}

function getUserTypes() {
  return service.Scrm_sys_api.srcmLogin.getUserTypes({ error: false })
}

function partnerDetail() {
  return service.Scrm_sys_api.srcmLogin.getPartnerInfo({ error: false })
}

function getUserInfoByToken() {
  return service.Scrm_sys_api.srcmLogin.getUserInfoByToken({ error: false })
}

async function AddLog(userId: string) {
  return service.Biz_api.srcmLogin.AddLog(userId)
}
function changeRole(role: number, router: any) {
  const __user = sessionStorage.getItem('__user')
  let userInfo: any = {}
  if (__user) {
    userInfo = JSON.parse(__user + '')

    if (userInfo?.user?.orgid === role) {
      console.warn('已是当前账户')
      return
    }
  }
  service.Scrm_sys_api.srcmLogin.changeRole({ error: true }, role).then((res) => {
    // if (res.data.userInfo.corpType !== 3 && res.data.userInfo.corpType !== 1) {
    // if (res.data.userInfo.type !== 3 && res.data.userInfo.type !== 1) {
    // todo 临时方案，后端将非3的角色归为个人0，3表示代理商
    // res.data.userInfo.corpType = 0
    // res.data.userInfo.type = 0
    // }
    if (res.success) {
      AddLog(res.data.userInfo.userId).then(async logRes => {
        if (logRes.success) {
          vuex.commit('set_data', {
            user: {
              token: res.data.token,
              info: res.data.userInfo,
              orgid: res.data.userInfo.corpId,
            },
          })
          // 获取企业认证信息
          try {
            const entEditionInfo = await service.Scrm_sys_api.srcmLogin.queryEntEditionInfoByCorpId({
              error: false,
              success: false,
            })
            if (entEditionInfo && entEditionInfo.success) {
              // 将企业认证信息添加到用户信息中
              res.data.userInfo.auditStatus = entEditionInfo.data.auditStatus
              res.data.userInfo.businessLicenseUrl = entEditionInfo.data.businessLicenseUrl
              res.data.userInfo.authorLetterUrl = entEditionInfo.data.authorLetterUrl
              res.data.userInfo.corpName = entEditionInfo.data.name
              console.log('entEditionInfo', entEditionInfo.data)
            }
          } catch (e) {
            console.error('获取企业认证信息失败:', e)
          }
          const menuCodes = userInfo?.user.info?.menuCodes || []
          const hasHomePage = menuCodes.indexOf('home') >= 0
          if (1 === res.data.userInfo.corpType && hasHomePage) {
            // if (1 === res.data.userInfo.type && hasHomePage) {
            vuex.commit('set_data', {
              tabsArr: [
                {
                  key: 'home',
                  name: `${lang('mainMenu.firstMenu.home')}&home`,
                  url: '/vshow/newHomePage',
                  parentKey: '',
                  child: [],
                },
              ],
            })
            router.push('/vshow/newHomePage').then(() => {
              // location.reload()
              const url = new URL(window.location.href);

              // 直接修改 searchParams 里的 token
              url.searchParams.set('token', res.data.token);
              window.location.replace(url.toString());
            })
          } else {
            vuex.commit('set_data', {
              tabsArr: [
                {
                  key: 'workBench',
                  name: `${lang('mainMenu.firstMenu.workBench')}&workBench`,
                  url: '/vshow/workBench/newBench',
                  parentKey: '',
                  child: [],
                },
              ],
            })
            const url = new URL(window.location.href);

            // 直接修改 searchParams 里的 token
            url.searchParams.set('token', res.data.token);
            window.location.replace(url.toString());
          }
        }
      })
    }
  })
}

//移除引导
function removeNode() {
  introJs().exit()
  const ele: any = document.querySelector('.el-message-box__wrapper')
  const ele2: any = document.querySelector('.v-modal')
  if (ele && ele2) {
    ele.remove()
    ele2.remove()
  }
}
// 轮询权限
class PollingAuth {
  orgid: number
  timeout: number
  constructor({ orgid, time = 20000 }: { orgid: number; time?: number }) {
    this.orgid = orgid
    this.timeout = time
  }
  timeint: number = 0
  runing: boolean = false
  start() {
    try {
      const orgid = this.orgid
      const timeout = this.timeout

      if (!orgid) return null

      this.runing = true
      isLoginOut = false
      let result: any
      let pollingAuthIn = false // 是否接口请求中

      const authquery = () => {
        if (!this.runing) return null
        this.timeint = window.setInterval(async () => {
          if (isLoginOut) return null
          try {
            if (!pollingAuthIn) {
              pollingAuthIn = true
              result = await service.Scrm_sys_api.srcmLogin.tokenCheck({ error: false })
              if (result.data != 1) {
                clearInterval(this.timeint)
                pollingAuthIn = false
                ElMessageBox.confirm(
                  lang('mainMenu.logout.token.content'),
                  lang('mainMenu.logout.token.title'),
                  {
                    confirmButtonText: lang('mainMenu.logout.token.confirm'),
                    cancelButtonText: lang('mainMenu.logout.token.cancel'),
                    confirmButtonClass: 'BtnAlert',
                    callback: (action: any) => {
                      removeNode()
                      vuex.commit('clear_data')
                      location.reload()
                      isHuawei === 'huawei'
                        ? router.replace('/huaweiyun/login')
                        : router.replace('/login')
                      pollingAuthIn = false
                    },
                  },
                )
                // vuex.commit('clear_data')
                isLoginOut = true
              }
              pollingAuthIn = false
            }
          } catch (e: any) {
            console.log(e, '这是轮询进入catch')
            pollingAuthIn = false
            if (e.response.status === 401) {
              ElMessageBox.confirm(
                '当前登录状态已过期,请重新登录',
                lang('mainMenu.logout.token.title'),
                {
                  confirmButtonText: lang('mainMenu.logout.token.confirm'),
                  cancelButtonText: lang('mainMenu.logout.token.cancel'),
                  confirmButtonClass: 'BtnAlert',
                  callback: (action: any) => {
                    removeNode()
                    // loginOut(orgid)
                    vuex.commit('clear_data')
                    // isLoginOut = true
                    location.reload()
                    isHuawei === 'huawei'
                      ? router.replace('/huaweiyun/login')
                      : router.replace('/login')
                    pollingAuthIn = false
                  },
                },
              )
              // vuex.commit('clear_data')
              isLoginOut = true
            }
            // 网络波动重试次数
            // netErrorTick += 1
            // if (e.message.indexOf('timeout') != -1) return
            // if (netErrorTick < 3) return
            // netErrorTick = 0
            // clearInterval(this.timeint)
            // // 错误则退出轮询
            // if (e.message != '数据不合法') {
            //   ElMessageBox.confirm(
            //     lang('mainMenu.logout.token.content'),
            //     lang('mainMenu.logout.token.title'),
            //     {
            //       confirmButtonText: lang('mainMenu.logout.token.confirm'),
            //       cancelButtonText: lang('mainMenu.logout.token.cancel'),
            //       confirmButtonClass: 'BtnAlert',
            //       callback: (action: any) => {
            //         removeNode()
            //         vuex.commit('clear_data')
            //         isHuawei === 'huawei'
            //           ? router.replace('/huaweiyun/login')
            //           : router.replace('/login')
            //       },
            //     },
            //   )
            //   return
            // }
            // loginOut(orgid)
          }
        }, timeout)
      }
      authquery()
    } catch (e: any) {
      return Promise.reject(e)
    }
  }
  stop() {
    this.runing = false
    this.timeint && clearInterval(this.timeint)
  }
}

// 获取系统消息
class SystemMessage {
  timeOut: number

  constructor({ time = 20000 }: { time?: number }) {
    this.timeOut = time
  }

  timer: number = 0

  getMessageInfo(userId: any) {
    service.MessageApi.queryMessageInfo({
      data: {
        publishChannel: 1,
      },
    })
      .then((resp: any) => {
        const { data, success } = resp
        if (success) {
          vuex.commit('set_data', {
            systemMessage: data,
          })
        }
      })
      .catch((e: any) => console.error(e))
  }

  start(userId: any) {
    this.getMessageInfo(userId)
    if (this.timer) return
    this.timer = window.setInterval(() => this.getMessageInfo(userId), this.timeOut)
  }

  stop() {
    this.timer && clearInterval(this.timer)
  }
}

export { loginOut, getUserTypes, partnerDetail, getUserInfoByToken, changeRole, PollingAuth, SystemMessage }
